import { Loader } from '@googlemaps/js-api-loader';

const apiKey = process.env.VUE_APP_GOOGLE_MAPS_API_KEY;

export default function() {
  if (!apiKey) {
    throw new Error('Missing VUE_APP_GOOGLE_MAPS_API_KEY for geocoder');
  }
  const loader = new Loader({
    apiKey,
    version: "weekly",
    libraries: ["places"]
  });
  return loader.load().then(google => {
    return new google.maps.Geocoder();
  });
}
